import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "utils/react-query.js";
import { updateBookmark } from "./api";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { id, label, url, description, bookmark } = values;

    return {
        id,
        label,
        url,
        description,
        bookmark,
    };
}

export const useUpdateBookmark = (options = {}) => {
    return useMutation({
        mutationFn: async ({ id, values }) => {
            const payload = buildPayload(values);
            const response = await updateBookmark({
                id,
                item: payload,
            });
            return response;
        },
        onSuccess: () => {
            toast.success("Bookmark updated successfully");
            queryClient.invalidateQueries({ queryKey: ["bookmark_links"] });
            options.onSuccess?.();
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error.message);
        },
    });
}